import { Injectable } from '@angular/core';
import { GemsHttpService } from "../../../../shared/services/gems-http.service";
import { constants } from '../../../../constants/all.constants';
import { Organization } from '../../../../domains/Organization';
import { ProcessedDistribution } from "../../../../domains/ProcessedDistribution"
import { OrganizationList } from 'client/app/domains/OrganizationList';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrintDistributionService {
  constructor(
    private gemsHttp: GemsHttpService
  ) { }

  loadData(personId) {
    const url = constants.apiRoutes.retirementPlanDocuments.GetLux2 + personId;
    return this.gemsHttp.get(url).pipe(
      map(mapDistributionsForPrinting),
      catchError(err => {
        console.error('error', err);
        return of([]);
      })
    );
  }
}

function mapDistributionsForPrinting(response: any) {
  const data = response.result;
  const organizations = [];
  let safeHarborDocuments = [];
  let adoptionAgreementDocuments = [];
  let addendums = [];
  let retirementSpds = [];
  let retirementSmms = [];

  for (const element of data) {
    const organization = element;

    const subgroup: Organization = {
      Name: organization.organization,
      SafeHarborDocuments: safeHarborDocuments,
      AdoptionAgreementDocuments: adoptionAgreementDocuments,
      RetirementSpds: retirementSpds,
      RetirementSmms: retirementSmms,
      PendingShAcknowledgements: [],
      PendingSmmAcknowledgements: [],
      PendingSpdAcknowledgements: [],
      PendingShAcknowledgementsVisible: false,
      PendingSmmAcknowledgementsVisible: false,
      PendingSpdAcknowledgementsVisible: false,
      SmmCheckedAll: false,
      SmmStartEnabled: false,
      SpdCheckedAll: false,
      SpdStartEnabled: false,
      Status: '',
      Expanded: false,
      Open: false,
      SpdMaster: false,
      SmmMaster: false
    }


    organizations.push(subgroup);
    safeHarborDocuments = [];
    adoptionAgreementDocuments = [];
    retirementSpds = [];
    retirementSmms = [];
  }
  const processedDistributions: ProcessedDistribution[] = [];
  for (var i = 0; i < data.length; i++) {
    var organization = data[i];
    var id = 0;
    if (organization.id)
      id = organization.id;

    for (var j = 0; j < organization.acknowledgements.processedSpdAcknowledgements.length; j++) {
      var acknowledgement = organization.acknowledgements.processedSpdAcknowledgements[j];


      const processedDistribution: ProcessedDistribution = {

        Id: id,
        RetirementSpdId: acknowledgement.retirementSpdId,
        Organization: acknowledgement.processedAcknowledgement.subgroupName,
        PlanDocument: acknowledgement.processedAcknowledgement.planDocument,
        Type: acknowledgement.processedAcknowledgement.type,
        EffectiveDate: acknowledgement.processedAcknowledgement.effectiveDate,
        EffectiveDateDisplay: acknowledgement.processedAcknowledgement.effectiveDateDisplay,
        DistributionDate: acknowledgement.distributionDate,
        DistributionMethod: acknowledgement.methodOfDelivery,
        Comments: acknowledgement.comments,
        SubmittedByFullName: acknowledgement.firstName + " " + acknowledgement.lastName,
        FewerThan100Participants: acknowledgement.participatCount < 100,
        English25Percent: acknowledgement.can25PercentRead === 'Yes',
        NumParticipantsLesser: acknowledgement.numberWhoReadSmallPlan,
        NonEnglishLanguageLesser: acknowledgement.languageForSmallPlan,
        MoreThan100Participants: acknowledgement.participatCount >= 100,
        English500: acknowledgement.can500Read === 'Yes',
        English10Percent: acknowledgement.can10PercentRead === 'Yes',
        NumParticipantsMore: acknowledgement.numberWhoReadLargePlan,
        NonEnglishLanguageMore: acknowledgement.languageForLargePlan,
        DownloadLink: acknowledgement.downloadLink,
        ParticipantNumber: acknowledgement.participatCount,
        SubmissionDate: new Date(Date.parse(acknowledgement.submissionDate)).toLocaleDateString(),
        Status: 'SENT',
        Expanded: false
      };
      processedDistributions.push(processedDistribution)
    }
  }

  const organizationList: OrganizationList = {
    Organizations: organizations,
    ProcessedDistributions: processedDistributions
  }

  return organizationList;

}
